
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topic/[slug]",
      function () {
        return require("private-next-pages/topic/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topic/[slug]"])
      });
    }
  